import { StoryTranslationType } from "../../features/story.types";

export const story: StoryTranslationType = {
  story: {
    parts: "أجزاء",
    part: "جزء",
    continueStory: "متابعة القصة",
    print: "طباعة",
    generatingSummary: "توليد ملخص",
    generatingContinuation: "توليد تكملة",
    pleaseWait: "الرجاء الانتظار...",
    backToDashboard: "العودة إلى لوحة القيادة",
    extractCharacters: "استخراج الشخصيات",
    foundCharacters: "الشخصيات المكتشفة",
    addSelectedCharacters: "إضافة الشخصيات المحددة",
    share: "مشاركة",
    viewEntire: "عرض القصة بالكامل",
    viewPaginated: "عرض القصة في صفحات",
    tooltips: {
      upgradeToContinue: "قم بالترقية لمتابعة القصص",
      upgradeToShare: "قم بالترقية لمشاركة القصص",
      upgradeToExtract: "قم بالترقية لاستخراج الشخصيات"
    },
    ratings: {
      submitted: "تم إرسال التقييم",
      thankYou: "شكراً لك على تقييم هذه القصة!",
      error: "خطأ",
      failedToSubmit: "فشل في إرسال التقييم"
    },
    sharing: {
      dialogTitle: "شارك قصتك",
      dialogDescription: "اختر أين تريد مشاركة قصتك",
      privacy: "خصوصية القصة",
      privacyLevels: {
        private: "خاص",
        public: "عام",
        friends: "الأصدقاء فقط"
      },
      platform: "منصة",
      selectPlatform: "اختر منصة",
      customMessage: "رسالة مخصصة",
      customMessagePlaceholder: "أضف رسالة إلى مشاركتك...",
      shareButton: "مشاركة القصة",
      successTitle: "تمت مشاركة القصة بنجاح",
      successMessage: "تمت مشاركة قصتك على {{platform}}",
      authRequired: "المصادقة مطلوبة",
      authMessage: "الرجاء تسجيل الدخول لمشاركة القصص."
    },
    upgrade: {
      title: "الترقية مطلوبة",
      continueDescription: "قم بترقية حسابك لإنشاء تسلسلات القصة.",
      continueFeature: "إنشاء تسلسلات القصة باشتراك متميز",
      shareDescription: "قم بترقية حسابك لمشاركة القصص.",
      shareFeature: "مشاركة القصص باشتراك أساسي",
      extractDescription: "قم بترقية حسابك لاستخراج الشخصيات.",
      extractFeature: "استخراج الشخصيات باشتراك متميز",
      upgradeButton: "الترقية الآن"
    }
  },
  storyEditor: {
    navigation: {
      previousPage: "الصفحة السابقة",
      continue: "متابعة",
      returnToDashboard: "العودة إلى لوحة القيادة",
      page: "صفحة",
      of: "من",
      remainingPages: "الصفحات المتبقية",
    },
    input: {
      customResponse: "استجابة مخصصة"
    },
    choices: {
      yourChoice: "اختيارك"
    },
    completedStory: {
      title: "اكتملت القصة",
      description: "وصلت قصتك إلى نهايتها!"
    },
  },
  imageGeneration:{
    ready: "جاهز",
    imageReady: "الصورة جاهزة",
    insufficientCredits: "رصيد غير كافٍ",
    needMoreCredits: "تحتاج المزيد من الرصيد",
    failed: "فشل",
    processing: "قيد المعالجة",
    pleaseWait: "الرجاء الانتظار",
    unexpectedError: "خطأ غير متوقع",
    generateImage: "إنشاء صورة",
    costsCredits: "يكلف رصيدًا",
    generatingImage: "جاري إنشاء الصورة",
    credits: "رصيد",
    creditsLabel: "رصيد",
    selectImage: "اختر صورة",
    selectImageDescription: "اختر صورة لتمثيل الحدث",
    selectPreferred: "اختر الصورة المفضلة",
    contentNotFound: "المحتوى غير موجود",
    saved: "تم حفظ الصورة",
    imageSaved: "تم حفظ الصورة",
    partialSuccess: "نجاح جزئي",
    someImagesFailed: "فشلت بعض الصور",
  },
  audioGeneration: {
    insufficientCredits: "رصيد غير كافٍ",
    generateAudio: "إنشاء صوت",
    generatingAudio: "جاري إنشاء الصوت",
    pleaseWait: "الرجاء الانتظار",
    failed: "فشل",
    success: "نجاح",
    audioReady: "الصوت جاهز",
    audioAvailable: "الصوت متاح"
  },
  storyRewrite:{
    rewritesLeft: "إعادة كتابة متبقية",
    rewriteStory: "إعادة كتابة القصة",
    rewriteComplete: "تمت إعادة كتابة القصة",
    refreshingContent: "تحديث المحتوى",
    refreshError: "خطأ في التحديث",
    refreshErrorMessage: "حدث خطأ غير متوقع أثناء تحديث القصة. يرجى المحاولة مرة أخرى.",
    noRewritesLeft: "لا توجد إعادات كتابة متبقية",
    tryPageRefresh: "جرب تحديث الصفحة",
  },
  loadingMessages: {
    craftingTheNextChapter: "صياغة الفصل التالي",
    weavingThePlotTwists: "نسج تقلبات الحبكة",
    yourAdventureIsAboutToUnfold: "مغامرتك على وشك أن تنكشف",
    developingTheCharacters: "تطوير الشخصيات",
    imaginingNewPossibilities: "تخيل إمكانيات جديدة",
  },
  success: {
    charactersSaved: "تم حفظ الشخصيات",
    charactersAddedToLibrary: "تمت إضافة الشخصيات إلى مكتبة الشخصيات",
  },
  storySetup: {
    titles: {
      new: "إنشاء قصة جديدة",
      edit: "تحرير القصة",
      continue: "متابعة القصة"
    },
    basicInfo: {
      storyTitle: "عنوان القصة",
      titlePlaceholder: "أدخل عنوان القصة",
      silverLining: "جوهر القصة",
      descriptionPlaceholder: "ما هي قصتك حقاً؟ سيساعد هذا في توجيه السرد.",
      genre: "النوع",
      selectGenre: "اختر النوع",
      environment: "البيئة",
      theme: "المواضيع",
      selectEnvironment: "اختر البيئة",
      storyLength: "طول القصة",
      storyLengthWithNumberOfPages: "طول القصة (عدد الصفحات)",
      selectLength: "اختر الطول",
      aiSuggest: "اقتراح الذكاء الاصطناعي",
      missingValues: "قيم مفقودة",
      fillRequired: "يرجى ملء جميع الحقول المطلوبة",
      titleGenerated: "تم إنشاء العنوان",
      generationError: "خطأ في الإنشاء",
      tryAgain: "يرجى المحاولة مرة أخرى",
      addCustomGenre: "إضافة نوع مخصص...",
      addCustomEnvironment: "إضافة بيئة مخصصة...",
      addCustomTheme: "إضافة موضوع مخصص...",
      autoGenerate: "توليد تلقائي",
      formDataGenerated: "تم توليد بيانات النموذج",
      dataUpdated: "تم تحديث البيانات",
      formDataEnhanced: "تم تحسين بيانات النموذج",
      noEnhancementsNeeded: "لا توجد تحسينات مطلوبة",
      formDataUpToDate: "بيانات النموذج محدثة",
      needSomeInfo: "تحتاج إلى بعض المعلومات الإضافية"
    },
    genres: {
      fantasy: "خيال",
      scienceFiction: "خيال علمي",
      mystery: "غموض",
      romance: "رومانسية",
      adventure: "مغامرة",
      horror: "رعب",
      historicalFiction: "خيال تاريخي",
      contemporary: "معاصر",
      superhero: "بطل خارق",
      kidsStory: "قصة أطفال",
      thriller: "إثارة"
    },
    environments: {
      urbanCity: "مدينة حضرية",
      medievalCastle: "قلعة من العصور الوسطى",
      spaceStation: "محطة فضائية",
      forest: "غابة",
      desert: "صحراء",
      ocean: "محيط",
      mountain: "جبل",
      smallTown: "بلدة صغيرة",
      futuristicMetropolis: "مدينة مستقبلية",
      underwaterKingdom: "مملكة تحت الماء",
      hauntedMansion: "قصر مسكون",
      mountainCavern: "كهف جبلي",
      dragonLair: "عرين التنين",
      researchLaboratory: "مختبر بحثي",
      futureCommunications: "اتصالات مستقبلية",
      magicalLibrary: "مكتبة سحرية",
      rainyNight: "ليلة ممطرة",
      ancientTemple: "معبد قديم"
    },
    storyLengths: {
      short: "قصير",
      medium: "متوسط",
      long: "طويل",
      natural: "طبيعي"
    },
    characters: {
      name: "اسم الشخصية",
      description: "وصف الشخصية",
      title: "الشخصيات",
      browseCharacters: "تصفح الشخصيات",
      makePublic: "جعل الشخصية عامة"
    },
    character: {
      name: "اسم الشخصية",
      namePlaceholder: "أدخل اسم الشخصية",
      role: "دور الشخصية",
      selectRole: "اختر دور الشخصية",
      description: "وصف الشخصية",
      descriptionPlaceholder: "أدخل وصف الشخصية",
      create: "إنشاء شخصية",
      update: "تحديث الشخصية",
      roles: {
        protagonist: "البطل الرئيسي",
        antagonist: "الخصم",
        deuteragonist: "البطل الثانوي",
        mentor: "المرشد",
        comic_relief: "شخصية كوميدية",
        mysterious: "شخصية غامضة",
        love_interest: "اهتمام عاطفي",
        anti_hero: "بطل مضاد",
        sidekick: "مساعد",
        shapeshifter: "متحول الشكل",
        guardian: "حارس",
        catalyst: "محفز"
      }
    },
    themeSection: {
      title: "المواضيع"
    },
    themeOptions: {
      friendship: "صداقة",
      love: "حب",
      betrayal: "خيانة",
      redemption: "خلاص",
      growth: "نمو",
      power: "قوة",
      justice: "عدالة",
      family: "عائلة",
      courageBravery: "شجاعة وجرأة",
      magicMythology: "سحر وأساطير",
      survival: "بقاء",
      warConflict: "حرب وصراع",
      freedomRebellion: "حرية وتمرد",
      violenceRevenge: "عنف وانتقام",
      passionEroticism: "عاطفة وإثارة",
      quest: "مهمة بحث",
      ancientWisdom: "حكمة قديمة",
      timeTravel: "السفر عبر الزمن",
      technology: "تكنولوجيا",
      paradox: "مفارقة",
      knowledge: "معرفة",
      magic: "سحر",
      discovery: "اكتشاف",
      identity: "هوية",
      sacrifice: "تضحية",
      transformation: "تحول"
    },
    buttons: {
      create: "إنشاء القصة",
      update: "تحديث القصة"
    },
    success: {
      title: "اكتملت إعدادات القصة",
      description: "تم إنشاء قصتك بنجاح وهي جاهزة لرحلتك الإبداعية."
    },
    failure: {
      title: "فشل في إعداد القصة",
      description: "حدث خطأ أثناء إعداد القصة. يرجى التحقق من المدخلات الخاصة بك والمحاولة مرة أخرى."
    },
  }
};
